// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__XfXjK","header":"panel_header__wEwm+","icon":"panel_icon__2pAki","title":"panel_title__kcoUT"};